import { 
    LOADING,
    MENU_TOGGLE,
    OverlayAction,
    OverlayState,
    BROADCAST_START,
    BROADCAST_END,
    DialogState,
    DIALOG_OPEN,
    DIALOG_CLOSE
} from "./types";
import { BroadcastType } from "./types";

// ------ STATE ------ //

const initialState: OverlayState = {
    menuOpen: false,
    loading: false,
    broadcast: {
        open: false,
        type: BroadcastType.INFO,
        message: ""
    },
    dialog: {
        open: false,
        content: null
    }
}

// ----- REDUCER ----- //


export default function overlayReducer(state = initialState, action: OverlayAction) : OverlayState
{
    switch(action.type)
    {
        case LOADING:
            return loading(state, action.value);
        case BROADCAST_START:
        case BROADCAST_END:
            return broadcast(state, action.value);
        case DIALOG_OPEN:
        case DIALOG_CLOSE:
            return dialog(state, action.value);
        case MENU_TOGGLE:
            return menuToggle(state);
        default:
            return state;
    }
}

// ----- ACTIONS ----- //

function loading(state: OverlayState, value: boolean) : OverlayState
{
    return {
        ...state,
        loading: value
    };
}

function broadcast(state: OverlayState, value: any)
{
    return {
        ...state,
        broadcast: {
            ...value
        }
    };
}

function dialog(state: OverlayState, value: DialogState)
{
    return {
        ...state,
        dialog: {
            ...dialog,
            ...value
        }
    }
}

function menuToggle(state: OverlayState) : OverlayState
{
    return {
        ...state,
        menuOpen: !state.menuOpen
    };
}

export function loadOverlay(state: OverlayState) : Promise<OverlayState>
{
    return new Promise<OverlayState>(resolve => resolve({
        ...state,
        loading: false
    }));
}

// -------------------- //